import { Flip, ToastContainer } from 'react-toastify';
import { Route, Routes } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import { Buffer } from 'buffer';
import { ModalsManager } from '../ModalsManager/ModalsManager';
import { SoundsContainer } from '../../sounds/SoundsContainer';
import { EnterPage } from '../../pages/EnterPage/EnterPage';
import { GamePage } from '../../pages/GamePage/GamePage';
import AppWalletProvider from '../../wallet-provider/AppWalletProvider';
import PlayerProvider from '../../contexts/playerContext';
import { LeaderboardPage } from '../../pages/LeaderboardPage/LeaderboardPage';
import { ProfilePage } from '../../pages/ProfilePage/ProfilePage';
import { SportsPicksPage } from '../../pages/SportsPickspage/SportsPicksPage';
import { ProfitPage } from '../../pages/ProfitPage/ProfitPage';
import { TransactionPage } from '../../pages/Transactions/Transactions';
import { UserMangePage } from '../../pages/UserMangePage/UserMangePage';

window.Buffer = Buffer;
export const App: React.FC = () => {
  return (
    <>
      <AppWalletProvider>
        <PlayerProvider>
          <Routes>
            <Route path="/" element={<EnterPage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/sports-picks" element={<SportsPicksPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/profit" element={<ProfitPage />} />
            <Route path="/transactions" element={<TransactionPage />} />
            <Route path="/table" element={<GamePage />} />
            <Route path="/players" element={<UserMangePage />} />
          </Routes>
          <ToastContainer transition={Flip} newestOnTop={false} limit={3} />
          {/* <ModalsManager /> */}
          <SoundsContainer />
        </PlayerProvider>
      </AppWalletProvider>
    </>
  );
};
